/**
 * @param {Number|String} value
 * @param {Boolean} isResidential
 * @returns {string} 'residential'|'business'
 */
export function getCustomerType(isResidential) {
  return isResidential === true ? 'residential' : 'business';
}

/**
 * @param {Object} servicesRequired - { gas: <Bool>, electricity:<Bool> }
 * @returns {String} 'gas'|'electricity|'dual'
 */
export function getFuelType(servicesRequired = {}) {
  return ['gas', 'electricity'].reduce((acc, curr) => {
    if (servicesRequired[curr] === true) {
      if (acc) {
        return 'dual';
      } else {
        return curr;
      }
    }
    return acc;
  }, null);
}

/**
 * @param {String} consumptionPeriodCode
 * @returns {Boolean}
 */
export function isValidConsumptionPeriodCode(consumptionPeriodCode) {
  return /^0([1-8])$/.test(consumptionPeriodCode);
}
